import clsx from 'clsx'
import type {CSSProperties} from 'react'
import {NavigationService} from 'swayok-react-mdb-ui-kit/services/NavigationService'

interface Props {
    url: string
    height?: number
    label?: string | null
    className?: string
    labelClassName?: string
    alt?: string
    fullLogoUrl?: string
    fullLogoWrapperStyle?: CSSProperties
    fullLogoStyle?: CSSProperties
    logoLabelStyle?: CSSProperties
}

// Логотип приложения с подписью для шапки и подвала сайта.
export function LogoWithLabel(props: Props) {

    const {
        url,
        height,
        label,
        className,
        labelClassName,
        alt,
        fullLogoUrl,
        fullLogoWrapperStyle,
        fullLogoStyle,
        logoLabelStyle,
    } = props

    const img = (
        <img
            src={fullLogoUrl ?? '/img/dotoku.svg'}
            alt={alt}
            height={height}
            style={fullLogoUrl ? fullLogoStyle : undefined}
        />
    )

    const imgWithWrapper = fullLogoUrl ? (
        <div
            style={fullLogoWrapperStyle}
            className="overflow-visible"
        >
            {img}
        </div>
    ) : img

    // <Link to="/"> не работает на некоторых страницах (пример: /login).
    return (
        <a
            href={url}
            className={clsx('logo-with-label', className)}
            onClick={event => {
                event.preventDefault()
                NavigationService.navigate(url)
            }}
        >
            {imgWithWrapper}
            {label && (
                <span
                    className={clsx('d-block logo-label', labelClassName)}
                    style={logoLabelStyle}
                >
                    {label}
                </span>
            )}
        </a>
    )
}
